module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/2-47a452233793d0f1aa7889a54217d401.jpg";